import { useOrganization } from '_/contexts/OrganizationContext';
import { useCreateDestination } from '_/hooks/useDestinations';
import React, { ReactElement } from 'react';

import DestinationFormPage from './DestinationFormPage';

const NewDestination = (): ReactElement => {
  const { selectedOrgSlug } = useOrganization();
  const { mutate: createDestinationMutation, isPending: isCreating } = useCreateDestination(selectedOrgSlug || '');

  const handleSubmit = (destination: any) => {
    createDestinationMutation(destination);
  };

  return <DestinationFormPage mode="create" onSubmit={handleSubmit} isSubmitting={isCreating} />;
};

export default NewDestination;
